import styles from './card_grid.module.scss';
import React from 'react';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    columns?: number;
    children: React.ReactNode;
}
export function CardGrid({columns = 3, children}: OwnProps) {
    return (
        <div
            className={classNames(styles.card_grid, {
                [styles.grid_two]: columns === 2,
                [styles.grid_four]: columns === 4,
                [styles.grid_three]: columns === 3,
            })}
        >
            {children}
        </div>
    );
}
